/**
 * Resolve the widget script URL for embed.
 *
 * Priority:
 * 1. REACT_APP_RESI_WIDGET_SCRIPT_URL — full URL to bundle on R2/S3/CDN (e.g. https://cdn.../widget.v3/resi-widget.js)
 * 2. REACT_APP_RESIBOT_API_URL + /widget/resi-widget.js (served by ResiBot FastAPI)
 *
 * Optional REACT_APP_RESI_WIDGET_VERSION — appended as ?v= or &v= for cache-busting on each deploy.
 */

function withCacheBust(url) {
  const version = process.env.REACT_APP_RESI_WIDGET_VERSION?.trim();
  if (!version || !url) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}v=${encodeURIComponent(version)}`;
}

export function getResiWidgetScriptUrl() {
  const explicit = process.env.REACT_APP_RESI_WIDGET_SCRIPT_URL?.trim();
  const api = process.env.REACT_APP_RESIBOT_API_URL?.trim();
  const fallback =
    api && `${api.replace(/\/+$/, "")}/widget/resi-widget.js`;
  return withCacheBust(explicit || fallback || "");
}
